import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Form, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { getRompslompAutoExpenses, setRompslompAutoExpenses } from '../../../services/RompslompService';
import { PasswordModal } from './RompslompSending';
import { apiMessage } from './rompslompUtils';

// Automatic sending of NEW 0% BTW expenses (default OFF). Switching it on stores the cutoff: only expenses created afterwards are sent.
export default function RompslompAutoExpenses({ reloadSending }) {
    const { t } = useTranslation();
    const [auto, setAuto] = useState(null);
    const [ask, setAsk] = useState(false);

    const load = useCallback(async () => {
        try { setAuto((await getRompslompAutoExpenses()).data); } catch (err) { toast.error(apiMessage(err, t, 'rompslomp.errors.generic')); }
    }, [t]);
    useEffect(() => { load(); }, [load]);

    if (!auto) return <Spinner animation="border" />;
    const gatesOk = auto.gates.every((g) => g.ok);

    const change = async (password) => {
        try {
            const res = await setRompslompAutoExpenses(!auto.enabled, password);
            setAuto(res.data);
            toast.success(t(res.data.enabled ? 'rompslomp.autoExpenses.switchedOn' : 'rompslomp.autoExpenses.switchedOff'));
            setAsk(false);
            reloadSending();
        } catch (err) {
            if (err.response?.data?.gates) setAuto((a) => ({ ...a, gates: err.response.data.gates }));
            toast.error(apiMessage(err, t, 'rompslomp.errors.generic'));
        }
    };

    return (
        <div data-testid="auto-expenses-controls">
            <p className="text-muted">{t('rompslomp.autoExpenses.hint')}</p>
            <Form.Check type="checkbox" id="auto-expenses-toggle" data-testid="toggle-auto-expenses" checked={auto.enabled}
                disabled={!auto.enabled && !gatesOk} onChange={() => setAsk(true)} label={t('rompslomp.autoExpenses.checkbox')} />
            <p className="mt-2 mb-1"><strong data-testid="auto-expenses-status">
                {auto.enabled ? t('rompslomp.autoExpenses.statusOn', { since: (auto.since || '').replace('T', ' ') }) : t('rompslomp.autoExpenses.statusOff')}
            </strong></p>
            {auto.last_run_at && <div className="small text-muted">{t('rompslomp.autoExpenses.lastRun', { time: auto.last_run_at.replace('T', ' ') })}</div>}
            {!auto.enabled && !gatesOk && <Alert variant="secondary" className="mt-2">{t('rompslomp.autoExpenses.cannotSwitchOn')}</Alert>}
            <PasswordModal show={ask} onHide={() => setAsk(false)}
                title={auto.enabled ? t('rompslomp.autoExpenses.switchOffTitle') : t('rompslomp.autoExpenses.switchOnTitle')}
                text={auto.enabled ? t('rompslomp.autoExpenses.offText') : t('rompslomp.autoExpenses.onText')}
                confirmLabel={auto.enabled ? t('rompslomp.auto.switchOff') : t('rompslomp.auto.switchOn')}
                onConfirm={change} />
        </div>
    );
}
